import { createIcon, IconColors } from './icon-utils';

export const SkinnyPlusIcon = createIcon({
  fill: IconColors.DarkGrey,
  path: 'M6.85714 0.857143C6.85714 0.383756 6.47338 0 6 0C5.52662 0 5.14286 0.383756 5.14286 0.857143V5.14286H0.857143C0.383756 5.14286 0 5.52662 0 6C0 6.47338 0.383756 6.85714 0.857143 6.85714H5.14286V11.1429C5.14286 11.6163 5.52662 12 6 12C6.47338 12 6.85714 11.6163 6.85714 11.1429V6.85714H11.1429C11.6163 6.85714 12 6.47338 12 6C12 5.52662 11.6163 5.14286 11.1429 5.14286H6.85714V0.857143Z',
  style: {
    height: 12,
    width: 12,
  },
  viewBox: '0 0 12 12',
});

// https://svgur.com/i/snR.svg

// https://svgur.com/i/soX.svg

// https://svgur.com/i/sre.svg

// https://www.streamlinehq.com/icons/legacy-streamline-regular/files-folders/common-files/common-file-text-edit

// https://www.streamlinehq.com/icons/legacy-streamline-regular/work-office-companies/office-files/office-file-text

// https://svgur.com/i/sqt.svg

// https://svgur.com/i/srV.svg

// https://svgur.com/i/ssb.svg

// https://www.streamlinehq.com/icons/legacy-streamline-regular/files-folders/files-copyright/file-copyright-equal

// https://svgur.com/i/ssU.svg

// https://svgur.com/i/tJd.svg
